(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!customElements.get('pd-family-catalog')) customElements.define('pd-family-catalog', class extends HTMLElement {
  connectedCallback() {
    this.started = false;
    this.abort = new AbortController();
    queueMicrotask(() => {
      this.mount();
      this.observer = new MutationObserver(() => {
        const grid = this.closest('results-list')?.querySelector('.product-grid');
        const cards = grid ? [...grid.querySelectorAll('[data-pd-family-card]')] : [];
        if (this.renderedCards && (!this.querySelector('.pd-family-count') || cards.length !== this.renderedCards.length || cards.some((card, i) => card !== this.renderedCards[i]))) {
          this.abort.abort();
          this.abort = new AbortController();
          this.started = false;
          this.renderedCards = null;
          this.mount();
        }
      });
      const root = this.closest('results-list');
      if (root) this.observer.observe(root, {childList:true, subtree:true});
    });
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  async mount() {
    const root = this.closest('results-list');
    if (!root || this.started) return;
    this.started = true;
    const grid = root.querySelector('.product-grid');
    if (!grid) return;
    const current = Number(this.dataset.currentPage);
    const pages = Number(this.dataset.pages);
    const pageSize = Number(this.dataset.pageSize) || 24;
    const batches = new Map([[current, [...grid.querySelectorAll('[data-pd-family-card]')]]]);
    try {
      // Use Shopify's rendered, filtered results so colour/size/price and sort remain authoritative.
      for (let p = 1; p <= pages; p++) {
        if (p === current) continue;
        const url = new URL(location.href);
        url.searchParams.set('page', String(p));
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.delete('family_page');
        const response = await fetch(url, {signal: this.abort.signal});
        if (!response.ok) throw new Error('Could not load product options');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!doc.querySelector('pd-family-catalog')) throw new Error('Incomplete catalogue response');
        batches.set(p, [...doc.querySelectorAll('[data-pd-family-card]')].map(card => document.importNode(card, true)));
      }
      if (!this.isConnected || this.abort.signal.aborted) return;
      const cards = [...batches.keys()].sort((a,b) => a-b).flatMap(p => batches.get(p));
      // Pick the cheapest matching family member, including later result pages.
      // Keep the family's original position unless the shopper sorts by price.
      const priceOf = card => {
        const raw = card.dataset.pdPrice;
        const price = raw === undefined || raw === '' ? NaN : Number(raw);
        return Number.isFinite(price) ? price : Infinity;
      };
      const cheapestByFamily = new Map();
      for (const card of cards) {
        if (card.dataset.pdExpand === 'true' || !card.dataset.pdFamily) continue;
        const key = card.dataset.pdFamily;
        const previous = cheapestByFamily.get(key);
        if (!previous || priceOf(card) < priceOf(previous)) cheapestByFamily.set(key, card);
      }
      const seen = new Set();
      const visible = cards.filter(card => {
        const key = card.dataset.pdFamily;
        if (card.dataset.pdExpand === 'true' || !key) return true;
        if (seen.has(key)) return false;
        seen.add(key); return true;
      }).map(card => {
        if (card.dataset.pdExpand === 'true' || !card.dataset.pdFamily) return card;
        return cheapestByFamily.get(card.dataset.pdFamily);
      });
      const priceSort = new URL(location.href).searchParams.get('sort_by');
      if (priceSort === 'price-ascending' || priceSort === 'price-descending') {
        const direction = priceSort === 'price-ascending' ? 1 : -1;
        visible.sort((a, b) => (priceOf(a) - priceOf(b)) * direction);
      }
      root.querySelectorAll('.pagination').forEach(el => el.hidden = true);
      const totalPages = Math.max(1, Math.ceil(visible.length / pageSize));
      const pager = document.createElement('nav');
      pager.className = 'pd-family-pagination';
      pager.setAttribute('aria-label', 'Product pages');
      const status = document.createElement('p');
      status.className = 'pd-family-count';
      status.setAttribute('aria-live', 'polite');
      this.replaceChildren(status, pager);
      const show = (page, updateUrl = false) => {
        page = Math.min(totalPages, Math.max(1, page));
        this.renderedCards = visible.slice((page-1)*pageSize, page*pageSize);
        grid.replaceChildren(...this.renderedCards);
        grid.querySelectorAll('[data-pd-family-card]').forEach((card, index) => {
          card.className = card.className.replace(/product-grid__item--\d+/g, 'product-grid__item--' + index);
          card.dataset.page = String(page);
        });
        const text = visible.length === cards.length ? `${visible.length} ${visible.length === 1 ? "item" : "items"}` : `${visible.length} ${visible.length === 1 ? "style" : "styles"} · ${cards.length} options`;
        root.querySelectorAll('.products-count-wrapper').forEach(el => el.textContent = text);
        status.textContent = visible.length ? `Showing ${(page-1)*pageSize+1}–${Math.min(page*pageSize,visible.length)} of ${visible.length}` : 'No matching products';
        pager.replaceChildren();
        pager.hidden = totalPages < 2;
        for (let p = 1; p <= totalPages; p++) {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = String(p);
          button.setAttribute('aria-label', 'Page ' + p);
          if (p === page) button.setAttribute('aria-current', 'page');
          button.addEventListener('click', () => { show(p, true); root.scrollIntoView({block:'start',behavior:'instant'}); });
          pager.append(button);
        }
        if (updateUrl) {
          const url = new URL(location.href);
          url.searchParams.delete('page');
          if (page > 1) url.searchParams.set('family_page', String(page)); else url.searchParams.delete('family_page');
          history.pushState({}, '', url);
        }
      };
      show(Number(new URL(location.href).searchParams.get('family_page')) || 1);
      window.addEventListener('popstate', () => show(Number(new URL(location.href).searchParams.get('family_page')) || 1), {signal:this.abort.signal});
    } catch (error) {
      // Keep the complete native results and pagination usable if a request fails.
      if (error.name !== 'AbortError') this.textContent = '';
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product-enhancements"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pd-product-tools'))customElements.define('pd-product-tools',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();this.mount();document.addEventListener('shopify:section:load',()=>this.mount(),{signal:this.abort.signal});}
 disconnectedCallback(){this.abort?.abort();this.popup?.remove();document.querySelectorAll('[data-pd-inserted]').forEach(el=>el.remove());}
 mount(){const details=document.querySelector('.product-information .product-details');if(!details)return;details.querySelectorAll('[data-pd-inserted]').forEach(el=>el.remove());const target=details.querySelector('variant-picker')||details.querySelector('product-form-component');this.querySelectorAll('template[data-pd-options]').forEach(t=>{const el=t.content.firstElementChild.cloneNode(true);el.dataset.pdInserted='true';if(target)target.before(el);else details.append(el);});details.querySelectorAll('variant-picker label').forEach(l=>{const input=l.querySelector('input');const name=input?.value||l.textContent.trim();if(name)l.title=name;});const gallery=document.querySelector('.product-information media-gallery');if(!gallery)return;document.querySelectorAll('.pd-zoom-caption').forEach(el=>el.remove());const caption=document.createElement('p');caption.className='pd-zoom-caption';caption.dataset.pdInserted='true';caption.textContent=this.dataset.zoom==='true'?'Hover to inspect · Click or tap to enlarge':'Click or tap to enlarge';gallery.after(caption);if(this.bound)return;this.bound=true;if(this.dataset.zoom!=='true')return;const popup=document.createElement('div');popup.className='pd-magnifier';popup.hidden=true;popup.setAttribute('aria-hidden','true');document.body.append(popup);this.popup=popup;const hide=()=>popup.hidden=true;document.addEventListener('pointermove',e=>{if(!matchMedia('(hover:hover) and (pointer:fine) and (min-width:990px)').matches||document.querySelector('dialog[open]'))return hide();const slide=e.target.closest?.('.product-information media-gallery .product-media-container--image');if(!slide||slide.closest('dialog'))return hide();const img=slide.querySelector('img');if(!img||!img.complete||!img.naturalWidth)return hide();const box=img.getBoundingClientRect();const scale=Math.min(box.width/img.naturalWidth,box.height/img.naturalHeight);const w=img.naturalWidth*scale,h=img.naturalHeight*scale;const left=box.left+(box.width-w)/2,top=box.top+(box.height-h)/2;const x=e.clientX-left,y=e.clientY-top;if(x<0||y<0||x>w||y>h)return hide();const factor=Number(this.dataset.factor)||2;const source=new URL(img.currentSrc||img.src);source.searchParams.set('width','2000');popup.style.backgroundImage='url("'+source.href+'")';popup.style.backgroundSize=(w*factor)+'px '+(h*factor)+'px';popup.style.backgroundPosition=(160-x*factor)+'px '+(160-y*factor)+'px';const right=box.right+18;popup.style.left=(right+320<innerWidth-16?right:Math.max(16,box.left-338))+'px';popup.style.top=Math.max(16,Math.min(box.top,innerHeight-336))+'px';popup.hidden=false;},{signal:this.abort.signal});document.addEventListener('scroll',hide,{capture:true,passive:true,signal:this.abort.signal});document.addEventListener('pointerout',e=>{if(!e.relatedTarget)hide();},{signal:this.abort.signal});document.addEventListener('keydown',e=>{if(e.key==='Escape')hide();},{signal:this.abort.signal});}
});
// Keep separate Shopify products, but navigate between family members in place.
if (!window.pdFamilyNavigation) {
  window.pdFamilyNavigation = true;
  const cache = new Map();
  let sequence = 0;
  let activeUrl = location.href;
  const familyLink = event => event.target.closest?.('.product-information .pd-option-link');
  const keyFor = href => { const url = new URL(href, location.href); url.hash = ''; return url.href; };
  async function load(href) {
    const key = keyFor(href);
    const prior = cache.get(key);
    if (prior && Date.now() - prior.time < 30000) return prior.promise;
    const promise = fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) })
      .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.text(); })
      .then(html => {
        const page = new DOMParser().parseFromString(html, 'text/html');
        if (!page.querySelector('.product-information') || !page.querySelector('pd-product-tools')) throw new Error('Missing product');
        return page;
      });
    cache.set(key, { time: Date.now(), promise });
    if (cache.size > 12) cache.delete(cache.keys().next().value);
    promise.catch(() => { if (cache.get(key)?.promise === promise) cache.delete(key); });
    return promise;
  }
  function warm(event) {
    const link = familyLink(event);
    if (!link || link.origin !== location.origin || link.getAttribute('aria-current') === 'page') return;
    load(link.href).catch(() => {});
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);
  async function navigate(href, pop = false) {
    const ticket = ++sequence;
    const current = document.querySelector('.product-information');
    const tools = document.querySelector('pd-product-tools');
    if (!current || !tools) return location.assign(href);
    const scroll = { x: scrollX, y: scrollY };
    current.setAttribute('aria-busy', 'true');
    current.querySelectorAll('product-form-component').forEach(form => form.inert = true);
    let status = current.querySelector('.pd-family-status');
    if (!status) {
      status = document.createElement('p'); status.className = 'pd-family-status';
      status.setAttribute('role', 'status');
      current.querySelector('.pd-related-options')?.append(status);
    }
    status.textContent = 'Loading selection…';
    try {
      const page = await load(href);
      if (ticket !== sequence) return;
      const next = document.importNode(page.querySelector('.product-information'), true);
      const nextTools = page.querySelector('pd-product-tools');
      const nextForm = next.querySelector('product-form-component');
      const merchandise = nextForm?.querySelector('input[name="id"]');
      const quantityVariant = nextForm?.querySelector('quantity-selector-component')?.dataset.variantId;
      if (!merchandise?.value || (quantityVariant && quantityVariant !== merchandise.value)) throw new Error('Incomplete purchase data');
      // Each form and gallery is recreated from Shopify's rendered product markup.
      // This includes the merchandise ID, availability, variants and delivery data.
      current.replaceWith(next);
      tools.replaceChildren(...Array.from(nextTools.childNodes, node => document.importNode(node, true)));
      tools.mount();
      const oldRecommendations = document.querySelector('product-recommendations');
      const newRecommendations = page.querySelector('product-recommendations');
      if (oldRecommendations && newRecommendations) oldRecommendations.replaceWith(document.importNode(newRecommendations, true));
      document.title = page.title;
      for (const selector of ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:url"]', 'meta[property="og:image"]']) {
        const old = document.head.querySelector(selector), fresh = page.head.querySelector(selector);
        if (old && fresh) old.replaceWith(document.importNode(fresh, true));
      }
      if (!pop) history.pushState({ ...history.state, pdFamily: true }, '', href);
      activeUrl = location.href;
      const selected = next.querySelector('.pd-option-link[aria-current="page"]');
      if (!pop) selected?.focus({ preventScroll: true });
      const announcement = document.createElement('span');
      announcement.className = 'visually-hidden'; announcement.setAttribute('role', 'status');
      announcement.textContent = 'Selected ' + (selected?.title || page.title);
      next.append(announcement);
      window.scrollTo({ left: scroll.x, top: scroll.y, behavior: 'instant' });
      document.dispatchEvent(new CustomEvent('pd:family:change', { detail: { url: activeUrl } }));
    } catch (error) {
      if (ticket === sequence) location.assign(href);
    }
  }
  document.addEventListener('click', event => {
    const link = familyLink(event);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.origin !== location.origin) return;
    event.preventDefault();
    if (keyFor(link.href) === keyFor(activeUrl) && !document.querySelector('.product-information[aria-busy]')) return;
    navigate(link.href);
  });
  window.addEventListener('popstate', () => {
    if (location.href === activeUrl) return;
    if (location.pathname.includes('/products/') && document.querySelector('pd-product-tools')) navigate(location.href, true);
    else location.reload();
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
if (!customElements.get('pd-family-catalog')) customElements.define('pd-family-catalog', class extends HTMLElement {
  connectedCallback() {
    this.started = false;
    this.abort = new AbortController();
    queueMicrotask(() => {
      this.mount();
      this.observer = new MutationObserver(() => {
        const grid = this.closest('results-list')?.querySelector('.product-grid');
        const cards = grid ? [...grid.querySelectorAll('[data-pd-family-card]')] : [];
        if (this.renderedCards && (!this.querySelector('.pd-family-count') || cards.length !== this.renderedCards.length || cards.some((card, i) => card !== this.renderedCards[i]))) {
          this.abort.abort();
          this.abort = new AbortController();
          this.started = false;
          this.renderedCards = null;
          this.mount();
        }
      });
      const root = this.closest('results-list');
      if (root) this.observer.observe(root, {childList:true, subtree:true});
    });
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  async mount() {
    const root = this.closest('results-list');
    if (!root || this.started) return;
    this.started = true;
    const grid = root.querySelector('.product-grid');
    if (!grid) return;
    const current = Number(this.dataset.currentPage);
    const pages = Number(this.dataset.pages);
    const pageSize = Number(this.dataset.pageSize) || 24;
    const batches = new Map([[current, [...grid.querySelectorAll('[data-pd-family-card]')]]]);
    try {
      // Use Shopify's rendered, filtered results so colour/size/price and sort remain authoritative.
      for (let p = 1; p <= pages; p++) {
        if (p === current) continue;
        const url = new URL(location.href);
        url.searchParams.set('page', String(p));
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.delete('family_page');
        const response = await fetch(url, {signal: this.abort.signal});
        if (!response.ok) throw new Error('Could not load product options');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!doc.querySelector('pd-family-catalog')) throw new Error('Incomplete catalogue response');
        batches.set(p, [...doc.querySelectorAll('[data-pd-family-card]')].map(card => document.importNode(card, true)));
      }
      if (!this.isConnected || this.abort.signal.aborted) return;
      const cards = [...batches.keys()].sort((a,b) => a-b).flatMap(p => batches.get(p));
      // Pick the cheapest matching family member, including later result pages.
      // Keep the family's original position unless the shopper sorts by price.
      const priceOf = card => {
        const raw = card.dataset.pdPrice;
        const price = raw === undefined || raw === '' ? NaN : Number(raw);
        return Number.isFinite(price) ? price : Infinity;
      };
      const cheapestByFamily = new Map();
      for (const card of cards) {
        if (card.dataset.pdExpand === 'true' || !card.dataset.pdFamily) continue;
        const key = card.dataset.pdFamily;
        const previous = cheapestByFamily.get(key);
        if (!previous || priceOf(card) < priceOf(previous)) cheapestByFamily.set(key, card);
      }
      const seen = new Set();
      const visible = cards.filter(card => {
        const key = card.dataset.pdFamily;
        if (card.dataset.pdExpand === 'true' || !key) return true;
        if (seen.has(key)) return false;
        seen.add(key); return true;
      }).map(card => {
        if (card.dataset.pdExpand === 'true' || !card.dataset.pdFamily) return card;
        return cheapestByFamily.get(card.dataset.pdFamily);
      });
      const priceSort = new URL(location.href).searchParams.get('sort_by');
      if (priceSort === 'price-ascending' || priceSort === 'price-descending') {
        const direction = priceSort === 'price-ascending' ? 1 : -1;
        visible.sort((a, b) => (priceOf(a) - priceOf(b)) * direction);
      }
      root.querySelectorAll('.pagination').forEach(el => el.hidden = true);
      const totalPages = Math.max(1, Math.ceil(visible.length / pageSize));
      const pager = document.createElement('nav');
      pager.className = 'pd-family-pagination';
      pager.setAttribute('aria-label', 'Product pages');
      const status = document.createElement('p');
      status.className = 'pd-family-count';
      status.setAttribute('aria-live', 'polite');
      this.replaceChildren(status, pager);
      const show = (page, updateUrl = false) => {
        page = Math.min(totalPages, Math.max(1, page));
        this.renderedCards = visible.slice((page-1)*pageSize, page*pageSize);
        grid.replaceChildren(...this.renderedCards);
        grid.querySelectorAll('[data-pd-family-card]').forEach((card, index) => {
          card.className = card.className.replace(/product-grid__item--\d+/g, 'product-grid__item--' + index);
          card.dataset.page = String(page);
        });
        const text = visible.length === cards.length ? `${visible.length} ${visible.length === 1 ? "item" : "items"}` : `${visible.length} ${visible.length === 1 ? "style" : "styles"} · ${cards.length} options`;
        root.querySelectorAll('.products-count-wrapper').forEach(el => el.textContent = text);
        status.textContent = visible.length ? `Showing ${(page-1)*pageSize+1}–${Math.min(page*pageSize,visible.length)} of ${visible.length}` : 'No matching products';
        pager.replaceChildren();
        pager.hidden = totalPages < 2;
        for (let p = 1; p <= totalPages; p++) {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = String(p);
          button.setAttribute('aria-label', 'Page ' + p);
          if (p === page) button.setAttribute('aria-current', 'page');
          button.addEventListener('click', () => { show(p, true); root.scrollIntoView({block:'start',behavior:'instant'}); });
          pager.append(button);
        }
        if (updateUrl) {
          const url = new URL(location.href);
          url.searchParams.delete('page');
          if (page > 1) url.searchParams.set('family_page', String(page)); else url.searchParams.delete('family_page');
          history.pushState({}, '', url);
        }
      };
      show(Number(new URL(location.href).searchParams.get('family_page')) || 1);
      window.addEventListener('popstate', () => show(Number(new URL(location.href).searchParams.get('family_page')) || 1), {signal:this.abort.signal});
    } catch (error) {
      // Keep the complete native results and pagination usable if a request fails.
      if (error.name !== 'AbortError') this.textContent = '';
    }
  }
});


  } catch(e) { console.error(e); }
})();
})();
